import { browserHistory } from "react-router";
import {confirm} from 'util/confirm'
import updateClassTeacher from 'controllers/teacher/updateClassTeacher'
import {fetchClassTeacher} from './ducks'
import {fetchClassLesson} from '../ducks'
import { userCan } from 'containers/__R';


export default function getDefaultTableSettings() {
  let TabComponent = this;
  let {dispatch, classDetail} = this.props
  const {cType} = classDetail.detail
  const classId = this.props.params.classId
	return [
    {
      title: __('Exit Class', 'classdetail'),
      onClick: ({trData: teacherInfo})=>{
        const {stName} = teacherInfo
        confirm(__('Exit Teacher: {name} From Class?', 'classdetail', {name: stName})).then(()=>{
          updateClassTeacher(classId, teacherInfo.id, {state: 'archive'})
          .then((res) => {
            dispatch(fetchClassTeacher(classId))
            //dispatch(fetchClassLesson(classId))
          })
          .catch((err) => {console.log(err)})
        })
      },
      isDisabled: () => {
        return !userCan(cType == 0? 'archive_teacher_from_class': 'archive_teacher_from_private_class');
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/TeacherTable/table-settings.js